import * as Components from 'components';
import { RevenueShareInterface } from 'content/type';
import React from 'react';
import { SetURLSearchParams } from 'react-router-dom';

interface RevenueShareTableProps {
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
  dataFetch: (params: URLSearchParams) => Promise<{ data: RevenueShareInterface[]; count: number }>;
}

export const RevenueShareTable: React.FC<RevenueShareTableProps> = ({
  searchParams,
  setSearchParams,
  dataFetch,
}) => {
  const idColumn =
    searchParams.get('group_by') === 'content'
      ? [
          {
            title: 'Episode ID',
            dataIndex: 'episode_id',
            key: 'episode_id',
            width: '5%',
          },
        ]
      : [];
  const columns = [
    ...idColumn,
    {
      title: 'Year/Month',
      dataIndex: 'yearmon',
      key: 'yearmon',
      width: '8%',
    },
    {
      title: 'Content Provider',
      dataIndex: 'content_provider',
      key: 'content_provider',
      width: '10%',
    },
    {
      title: 'Title',
      dataIndex: 'title_ko',
      key: 'title_ko',
      width: '10%',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      render: (_: any, record: RevenueShareInterface): React.ReactNode => {
        return (
          <a
            href={
              searchParams.get('group_by') === 'content'
                ? `/video/detail/${record.content_id}`
                : `/season/edit/${record.season_id}`
            }
            target="_blank"
            rel="noopener noreferrer"
          >
            {record.title_ko}
          </a>
        );
      },
    },
    {
      title: 'SVOD Revenue',
      dataIndex: 'svod_revenue',
      key: 'svod_revenue',
      width: '8%',
    },
    {
      title: 'SVOD Net Revenue',
      dataIndex: 'svod_net_revenue',
      key: 'svod_net_revenue',
      width: '8%',
    },
    {
      title: 'SVOD VH',
      dataIndex: 'svod_vh',
      key: 'svod_vh',
      width: '8%',
    },
    {
      title: 'SVOD VP',
      dataIndex: 'svod_vp',
      key: 'svod_vp',
      width: '8%',
    },
    {
      title: 'AVOD Revenue',
      dataIndex: 'avod_revenue',
      key: 'avod_revenue',
      width: '8%',
    },
    {
      title: 'AVOD Net Revenue',
      dataIndex: 'net_avod_revenue',
      key: 'net_avod_revenue',
      width: '8%',
    },
    {
      title: 'AVOD VH',
      dataIndex: 'avod_vh',
      key: 'avod_vh',
      width: '8%',
    },
    {
      title: 'AVOD VP',
      dataIndex: 'avod_vp',
      key: 'avod_vp',
      width: '8%',
    },
    {
      title: 'AVOD RS Rate',
      dataIndex: 'avod_rs_rate',
      key: 'avod_rs_rate',
      width: '8%',
    },
    {
      title: 'AVOD X RS Rate',
      dataIndex: 'avod_x_rs_rate',
      key: 'avod_x_rs_rate',
      width: '8%',
    },
    {
      title: 'Total RS Amount',
      dataIndex: 'total_rs_amount',
      key: 'total_rs_amount',
      width: '8%',
    },
  ];

  return (
    <Components.TableComponent
      name="Revenue Share"
      columns={columns}
      searchParams={searchParams}
      setSearchParams={setSearchParams}
      options={{ isDisableIdColumn: true }}
      dataFetch={dataFetch}
    />
  );
};
